import { render } from "./DefinirSenha.vue?vue&type=template&id=6e5d0c2c&scoped=true"
import script from "./DefinirSenha.vue?vue&type=script&lang=js"
export * from "./DefinirSenha.vue?vue&type=script&lang=js"

import "./DefinirSenha.vue?vue&type=style&index=0&id=6e5d0c2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5d0c2c"]])

export default __exports__